import { Button, Paper, useMediaQuery } from '@mui/material'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system'
import { ReactComponent as EmptyIcon } from 'Assets/img/empty.svg'
import OriginalMapsImage from 'Assets/img/mapcard_original.jpg'
import React from 'react'
import { Else, If, Then, When } from 'react-if'

import { useMapsQuery } from '../../../Queries/Maps'
import { useUserContentQuery } from '../../../Queries/Users'
import { PROFILE_IMAGE_TYPE } from '../../../Queries/utils'
import { CONTENT_TYPES } from '../../../Scenes/constants'
import { navigateToContestInvitation, navigateToProfileMapsPage } from '../../../Scenes/navigators'
import Avatar from '../../../Theme/Avatar'
import FAIcon from '../../../Theme/FAIcon'
import { FA_ICONS } from '../../../Theme/font-awesome-icon-constants'
import { BREAKPOINT_MIN_LG, BREAKPOINT_MIN_SM } from '../../../Theme/stylesUtil'
import CustomMuiTab from '../../../Theme/Tab'
import { transformTextWithThreeDots } from '../../../utils/text-transformation-utils'
import { userImageSelector } from '../../../utils/user-images-utils'
import { MapCard } from '../../_common/CollectionCard/MapCard'
import MobileMainHeader from '../../_common/MobileMainHeader'
import MapSkeletonWrapper from '../../_common/Skeletons/MapSkeletonWrapper'
import { useAuth } from '../../Auth'
import { ProfileSocialIcons } from '../../ProfileComponents/ProfileWidgets/ProfileSocialIcons'
import JudgeVotedMaps from '../JudgeVotedMaps'

const ContestJudgesBioModal = ({
  user,
  isUserFetched,
  favoriteMaps = [],
  bio,
  designPreference,
  loveAboutHalo,
  judges = [],
  isPreview = false,
  setActiveJudge,
  contestRelation,
  closeJudgesBio,
  judgeState,
  contestId,
  originalMaps,
}) => {
  const profile = user?.profile
  const { id } = useAuth()
  const { data: userMaps, isFetched } = useMapsQuery({ user_id: user.id, _sort: '-time_created', limit: 2, game_id: 6 })
  const { data: maps = [], isFetched: isMapsFetched } = useUserContentQuery(
    {
      id: user.id,
      sort: '-time_created',
      _limit: 3,
    },
    CONTENT_TYPES.MAPS,
    false,
  )

  const avatar = userImageSelector(user?.user_images, PROFILE_IMAGE_TYPE.AVATAR, 'medium')
  const isBiggerThanSMScreen = useMediaQuery(BREAKPOINT_MIN_SM)
  const isBiggerThanLGScreen = useMediaQuery(BREAKPOINT_MIN_LG)
  const isShowJudgeData = judgeState === 'accepted' || isPreview
  const isShowEditButton = user?.id === id

  const showAllUserMaps = () => {
    navigateToProfileMapsPage(user.id)
  }
  const handleSelectJudge = (judge) => {
    if (isPreview) return
    setActiveJudge(judge)
  }

  const isShowViewAll = isMapsFetched && maps.length > 1

  return (
    <Paper
      sx={{
        marginTop: isPreview ? '100px' : '35px',
        paddingBottom: '50px',
        minHeight: isPreview ? '1000px' : '0',
        borderRadius: '16px',
      }}
    >
      <If condition={isBiggerThanSMScreen}>
        <Then>
          {!isPreview ? (
            <Tabs
              value={user?.login || null}
              sx={{ width: '100%', paddingLeft: '25px' }}
              indicatorColor="secondary"
              textColor="secondary"
              variant="scrollable"
              scrollButtons={false}
            >
              {judges.map((judge) => (
                <CustomMuiTab
                  key={judge.login}
                  value={judge.login}
                  label={<Typography variant="h6">{transformTextWithThreeDots(judge.login)}</Typography>}
                  onClick={() => handleSelectJudge(judge)}
                />
              ))}
            </Tabs>
          ) : (
            <Tabs
              value={user.login}
              sx={{ width: '100%', paddingLeft: '25px' }}
              indicatorColor="secondary"
              textColor="secondary"
            >
              <CustomMuiTab
                value={user.login}
                label={<Typography variant="h6">{transformTextWithThreeDots(user.login)}</Typography>}
              />
            </Tabs>
          )}
        </Then>
        <Else>
          {!isPreview ? (
            <MobileMainHeader
              subheader={
                <Tabs
                  value={user?.login || null}
                  sx={{ width: '100%', paddingLeft: '25px' }}
                  indicatorColor="secondary"
                  variant="scrollable"
                  textColor="secondary"
                >
                  {judges.map((judge) => (
                    <CustomMuiTab
                      key={judge.login}
                      value={judge.login}
                      label={<Typography variant="h6">{transformTextWithThreeDots(judge.login)}</Typography>}
                      onClick={() => handleSelectJudge(judge)}
                    />
                  ))}
                </Tabs>
              }
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '15px' }}>
                <FAIcon
                  iconClassName={FA_ICONS.ARROW_LEFT}
                  color="text.tertiary"
                  onClick={closeJudgesBio}
                />
                <Typography
                  variant="h5"
                  color="text.primary"
                >
                  Judges Bio
                </Typography>
              </Box>
            </MobileMainHeader>
          ) : (
            <Tabs
              value={user.login}
              sx={{ width: '100%', paddingLeft: '25px' }}
              indicatorColor="secondary"
              textColor="secondary"
            >
              <CustomMuiTab
                value={user.login}
                label={<Typography variant="h6">{transformTextWithThreeDots(user.login)}</Typography>}
              />
            </Tabs>
          )}
        </Else>
      </If>
      <Box
        sx={{ backgroundColor: '#202126', borderRadius: '16px 16px 0 0', marginTop: isBiggerThanSMScreen ? 0 : '60px' }}
      />

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: isBiggerThanLGScreen ? '1fr 1fr' : '1fr',
          gap: '24px',
          margin: '24px',
        }}
      >
        <Box sx={{ marginTop: '24px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'start', marginTop: '24px' }}>
              <Box>
                <Avatar
                  size={'medium'}
                  src={avatar}
                />
              </Box>
              <ProfileSocialIcons
                profile={profile}
                user={user}
                isUserFetched={isUserFetched}
                fullWidth={true}
              />
            </Box>
            <When condition={isShowEditButton && !isPreview}>
              <Box>
                <Button
                  color="inherit"
                  startIcon={<FAIcon iconClassName={FA_ICONS.PEN_TO_SQUARE} />}
                  onClick={() => navigateToContestInvitation(contestId)}
                >
                  Edit bio
                </Button>
              </Box>
            </When>
          </Box>
          <JudgeVotedMaps
            contestRelation={contestRelation}
            ownerId={user.id}
            mapHeight={120}
            isWithPopper={false}
          />
          <If condition={(bio && designPreference && loveAboutHalo && isShowJudgeData) || isPreview}>
            <Then>
              <Box sx={{ marginTop: '24px', marginBottom: '15px' }}>
                <Typography
                  variant="body2"
                  color="text.tertiary"
                  sx={{ marginBottom: '10px' }}
                >
                  Bio
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ wordWrap: 'break-word' }}
                >
                  {bio}
                </Typography>
              </Box>
              <Box sx={{ marginTop: '24px', marginBottom: '15px' }}>
                <Typography
                  variant="body2"
                  color="text.tertiary"
                  sx={{ marginBottom: '10px' }}
                >
                  Map design preferences
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ wordWrap: 'break-word' }}
                >
                  {designPreference}
                </Typography>
              </Box>
              <Box sx={{ marginTop: '24px', marginBottom: '15px' }}>
                <Typography
                  variant="body2"
                  color="text.tertiary"
                  sx={{ marginBottom: '10px' }}
                >
                  What I love about Halo
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ wordWrap: 'break-word' }}
                >
                  {loveAboutHalo}
                </Typography>
              </Box>
            </Then>
            <Else>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: '130px',
                  marginBottom: '130px',
                }}
              >
                <Box>
                  <EmptyIcon />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    Waiting judge to fill up the info
                  </Typography>
                </Box>
              </Box>
            </Else>
          </If>
        </Box>

        <Box sx={{ flexBasis: '50%' }}>
          <Box
            sx={{
              backgroundSize: 'cover',
              padding: '15px',
              marginBottom: '15px',
              backdropFilter: 'brightness(80%)',
              backgroundPosition: 'center',
              backgroundImage: `linear-gradient(
              180deg,
              rgba(32, 33, 38, 0.2) 0%,
              rgba(32, 33, 38, 0.6446) 44.01%,
              rgba(32, 33, 38, 0.92) 100%),
              url(${OriginalMapsImage})`,
              height: '80px',
              borderRadius: '16px',
              overflow: 'hidden',
            }}
          >
            <Typography
              variant="h6"
              color="text.tertiary"
              sx={{ marginBottom: '10px' }}
            >
              Favorite Forge maps
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'start', gap: '15px' }}>
              {originalMaps.length > 0 &&
                originalMaps.map((map) => (
                  <Typography
                    key={map.id}
                    color="text.primary"
                    variant="h6"
                  >
                    {map.title}
                  </Typography>
                ))}
            </Box>
          </Box>
          <Box sx={{ marginBottom: '10px' }}>
            <Typography
              variant="h6"
              color="text.tertiary"
              sx={{ marginBottom: '10px' }}
            >
              Favorite Forge maps
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: isBiggerThanSMScreen ? '1fr 1fr' : '1fr',
                gridTemplateRows: '1fr 1fr',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              {favoriteMaps.length > 0 &&
                isShowJudgeData &&
                favoriteMaps.map((map) => (
                  <MapCard
                    key={map.id}
                    map={map}
                    style={{ height: '120px', flexBasis: '50%' }}
                  />
                ))}
              <MapSkeletonWrapper
                emptyMaps={!isShowJudgeData ? 4 : 4 - favoriteMaps.length}
                animation={false}
                height={120}
              />
            </Box>
          </Box>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
              <Typography
                variant="h6"
                color="text.tertiary"
              >
                Maps by {transformTextWithThreeDots(user?.login)}
              </Typography>
              <When condition={isShowViewAll}>
                <Button
                  color="secondary"
                  onClick={showAllUserMaps}
                >
                  View all
                </Button>
              </When>
            </Box>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: isBiggerThanSMScreen ? '1fr 1fr' : '1fr',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              {isFetched ? (
                userMaps.pages[0].data.map((map) => (
                  <If
                    key={map.id}
                    condition={userMaps.pages[0].data.length === 2}
                  >
                    <Then>
                      <MapCard
                        map={map}
                        style={{
                          height: '120px',
                          width: isBiggerThanSMScreen ? 'auto' : '100%',
                          flexBasis: isBiggerThanSMScreen ? '50%' : 'auto',
                        }}
                      />
                    </Then>
                    <Else>
                      <MapCard
                        key={map.id}
                        map={map}
                        style={{
                          height: '120px',
                          width: isBiggerThanSMScreen ? 'auto' : '100%',
                          flexBasis: isBiggerThanSMScreen ? '50%' : 'auto',
                        }}
                      />
                      <MapSkeletonWrapper
                        emptyMaps={2 - userMaps.pages[0].data.length || 0}
                        animation={false}
                        height={120}
                      />
                    </Else>
                  </If>
                ))
              ) : (
                <MapSkeletonWrapper
                  emptyMaps={2}
                  animation={false}
                  height={120}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  )
}

export default ContestJudgesBioModal
